import { LeadStato, LEAD_STATO_LABEL } from '../../types/lead';

const STATO_STYLE: Record<LeadStato, string> = {
  nuovo: 'bg-blue-100 text-blue-700 border border-blue-200',
  contattato: 'bg-amber-100 text-amber-700 border border-amber-200',
  qualificato: 'bg-purple-100 text-purple-700 border border-purple-200',
  convertito: 'bg-green-100 text-green-700 border border-green-200',
  scartato: 'bg-gray-100 text-gray-600 border border-gray-200',
};

interface Props {
  stato: LeadStato;
  className?: string;
}

export default function LeadStatoBadge({ stato, className = '' }: Props) {
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${STATO_STYLE[stato]} ${className}`}
    >
      {LEAD_STATO_LABEL[stato]}
    </span>
  );
}
